import React, { Component } from 'react';
import KPI from '../Components/Analytics/KPI';
import Feedback from '../Components/Features/Feedback';
import SmartPanel from '../Components/SmartPanel';
import AdvancedFiltering from '../Components/Features/AdvancedFiltering';
import Discussions from '../Components/QuickViews/Discussions';
import D365CRM from '../Components/QuickViews/D365CRM';
import TFS from '../Components/QuickViews/TFS';
import Jira from '../Components/QuickViews/Jira';
import MainSearch from '../Components/MainSearch';
import FetchTour from './Tour/FetchTour';
import FetchTips from './Features/FetchTips';
import Pinning from '../Components/Pinning/Pinning';
import PinEditor from '../Components/Pinning/PinEditor';
import Header from './Util/Header';
import { ContentContext } from '../Providers/ContentProvider';
import { fetchAPI } from '../Helpers/FetchAPIWrapper';
import { Row, Col, Button, Dropdown, Form, OverlayTrigger, Tooltip, Modal, } from 'react-bootstrap';
import { userLanguagePreference, targetSource, shouldUseSynonyms, cleanFetchXML, targetColor, targetName, LogSearch, boldWords, cleanLinks, clickTracker, cleanQuickView, decodeHTMLEntities, criticalErrors, quickViewLink, infieldSearchCreator, removeFlattenedThunderstoneHTMLTags } from '../Helpers/SearchHelpers';
import { getNamespaceDump } from '../Helpers/FeatureHelpers';
import { LMFTFY, generateLMFTFYLink } from '../Helpers/LMFTFYHeplers';
import { toast } from 'react-toastify';
import moment from 'moment';

import NoDataAnimation from '../images/629-empty-box.gif';
import NoCommit from '../images/10607-dog-avatar.png';
import arrow from '../images/arrow.png';

import '../App.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { QuickView } from './QuickViews/QuickView';

let controller = new AbortController();
let signal = controller.signal;
toast.configure();

let NoResults = false;

const thunderstoneURL = `https://fetch.ceridian.com/texis/search/main.xml?dropXSL=yes&pr=${process.env.REACT_APP_THUNDERSTONEPROFILE}&mode=&opts=&dropXSL=&sq=&prox=&rorder=&rprox=&rdfreq=&rwfreq=&rlead=&rdepth=&sufs=&order=`;

window.addEventListener('scroll', function () {
  const last_known_scroll_position = window.scrollY;
  const scrollTop = document.getElementsByClassName('scroll-top')[0];

  if (last_known_scroll_position > 550) {
    scrollTop.classList.add('active');
  } else {
    if (scrollTop) {
      scrollTop.classList.remove('active');
    }
  }
});

function abortPrevRequests() {
  controller.abort();
  controller = new AbortController();
  signal = controller.signal;
}

class Fetch extends Component {
  static contextType = ContentContext;

  constructor(props) {
    super(props);

    this.loadingRef = React.createRef();

    this.state = {
      hasQuickView: ['D365', 'Discussions', 'TFS'],
      additionalView: false,
      pinningScreen: false,
      searchCommit: this.props.initResultPage,
      isSearching: false,
      advanceFiltering: false,
      isFiltering: false,
      loadingLink: false,
      NoData: false,
      detailedView: false,
      Quickview: localStorage.getItem('quickview') === 'true',
      useSynonyms: false,
      isFetching: false,
      MoreResultsToCome: false,
      runTour: false,
      FetchTipAvailable: false,
      showAllTips: false,
      activePage: 0,
      searchSummary: [],
      activeD365QuickViews: [],
      searchResults: [],
      moreResults: [],
      searchPages: [],
      Namespaces: [],
      ErrorNotification: [],
      mainSearch: '',
      setTarget: '',
      componentRequest: '',
      defaultSmartPanelTab: this.props.initResultPage,
      language: userLanguagePreference()
    };
  }

  initialState(target, advancedSearchUrl) {
    criticalErrors(this);
    abortPrevRequests();
    this.observe(false);

    if (!advancedSearchUrl) {
      //if the search is not an avanced search then clear previously used filters
      const clearFilterButton = document.getElementsByClassName('clear-filters')[0];
      if (clearFilterButton) {
        clearFilterButton.click();
      }
    }

    sessionStorage.removeItem('LastFilters');

    // clear previous results
    this.setState({
      searchCommit: true,
      isSearching: true,
      advanceFiltering: false,
      searchResults: [],
      moreResults: [],
      activePage: 0,
      NoData: false,
      MoreResultsToCome: false,
      setTarget: target,
      componentRequest: 'Search',
      pinningScreen: false,
      failedMessage: false
    });
  }

  async componentDidMount() {
    const { setNamespaces, setClientName } = this.context;
    sessionStorage.removeItem('LastFilters');

    if (window.location.href.includes('q?search')) {
      this.LMFTFYSearch();
    }

    if (!localStorage.getItem('quickview')) {
      localStorage.setItem('quickview', true);
    }
    const { namespaces, clientName } = await getNamespaceDump();

    setNamespaces(namespaces);
    setClientName(clientName);

    this.setState({
      Namespaces: namespaces,
      clientArr: clientName
    });

  }

  componentDidUpdate(prevProps) {
    if (prevProps.initResultPage !== this.props.initResultPage) {
      this.setState({
        searchCommit: this.props.initResultPage
      });
    }
  }

  async LMFTFYSearch() {
    this.initialState();

    let url_string = window.location;
    let url = new URL(url_string);
    let search = url.search;

    if (search.indexOf('search') > -1) {
      // Pull LMFTFY Id from url and send to get thunderstone search data
      const LMFTFYdata = await LMFTFY(url.searchParams.get('search'));
      const { LMFTFYsearchQuery, LMFTFYUrl } = LMFTFYdata;

      this.setState({ mainSearch: LMFTFYsearchQuery });
      this.search(LMFTFYsearchQuery, 'All', LMFTFYUrl);
      window.history.pushState('', '', '/');
    }
  }

  processThunderstoneXML(resultXML) {
    const fetchData = cleanFetchXML(resultXML);
    if (!fetchData.Result) {
      NoResults = true;
      this.setState({
        NoData: true,
        isSearching: false,
      });
      return;
    }

    // If Thunderstone only returned 1 result and its not in an array. We need to still handle it as an array
    const fetchResults = Array.isArray(fetchData.Result) ? fetchData.Result : [fetchData.Result];
    const searchSummary = fetchData.Summary;
    const searchPages = fetchData.Summary.Pages;
    const ThunderstoneSearchUrl = fetchData.Summary.NextLink;
    const isMultiPage = fetchData.Summary.Pages && fetchData.Summary.Pages.length > 1;
    //set observer if multiple pages
    this.observe(isMultiPage);

    return { fetchResults, searchSummary, searchPages, ThunderstoneSearchUrl, isMultiPage };
  }

  search(mainSearch, target, advancedSearchUrl) {
    this.initialState(target || this.state.setTarget, advancedSearchUrl);
    //Update website title with search term
    document.title = 'Fetch: ' + this.state.mainSearch;

    const searchUrl = advancedSearchUrl || `${thunderstoneURL}&query=${shouldUseSynonyms(mainSearch)}+infield:enc:Language(${this.state.language})&mu=${targetSource(target || this.state.setTarget)}&rpp=20`;
    fetch(searchUrl, { signal })
      .then(success => success.text())
      .then(resultXML => {
        const { fetchResults, searchSummary, searchPages, ThunderstoneSearchUrl, isMultiPage } = this.processThunderstoneXML(resultXML);

        this.setState({
          searchResults: fetchResults,
          searchSummary: searchSummary,
          searchPages: searchPages,
          isSearching: false,
          ThunderstoneSearchUrl: ThunderstoneSearchUrl,
          SearchURL: searchUrl,
          MoreResultsToCome: isMultiPage
        });

        //Log this search in the DB
        LogSearch(this, this.state.mainSearch, target, searchUrl, NoResults, this.state.smartPanelDisplayed, false);
      }).catch(error => {
        this.setState({
          isSearching: false,
          failedMessage: error.message === 'The user aborted a request.'
        });
      });
  }

  getMoreSearchPage() {
    const url = `https://fetch.ceridian.com/${decodeURIComponent(this.state.ThunderstoneSearchUrl)}`;

    fetch(url, { signal })
      .then(success => success.text())
      .then(resultXML => {
        const { fetchResults, ThunderstoneSearchUrl, isMultiPage } = this.processThunderstoneXML(resultXML);

        this.setState({
          searchResults: this.state.searchResults.concat(fetchResults),
          ThunderstoneSearchUrl: ThunderstoneSearchUrl,
          MoreResultsToCome: isMultiPage
        });

      }).catch(error => {
        this.setState({
          isSearching: false,
          failedMessage: error.message === 'The user aborted a request.'
        });
      });
  }

  advancedSearch(selectedFilters) {

    // When using advanced filtering the order of the fields matter
    let advancedSearchUrl = `https://fetch.ceridian.com/texis/search/main.xml?&query=${shouldUseSynonyms(this.state.mainSearch)}`;

    // Source and date values has to be the last part of the search url otherwise thunderstone doesn't pick it up - get data and remove from obj before loop
    const sources = selectedFilters['Source'] && selectedFilters['Source'].replaceAll(', ', '&mu=');
    const dateFrom = selectedFilters['dateFrom'] !== null ? selectedFilters['dateFrom'] : '';
    const dateTo = selectedFilters['dateTo'] !== null ? selectedFilters['dateTo'] : '';
    const sortByDate = selectedFilters['sortByDate'] !== null ? 'dd' : '';

    delete selectedFilters.Source;
    delete selectedFilters.dateFrom;
    delete selectedFilters.dateTo;
    delete selectedFilters.sortByDate;

    for (const filter in selectedFilters) {
      const infield = infieldSearchCreator(filter, selectedFilters[filter]);
      advancedSearchUrl += infield;
    }

    // Add source to end of search url
    advancedSearchUrl += `+infield:enc:Language(${this.state.language})&dropXSL=yes&pr=${process.env.REACT_APP_THUNDERSTONEPROFILE}&prox=page&rorder=250&rprox=1000&rdfreq=0&rwfreq=500&rlead=1000&rdepth=0&sufs=2&mode=&opts=&sr=-1&mu=${sources}&qpModifiedAfter=${dateFrom}&qpModifiedBefore=${dateTo}&order=${sortByDate}&rpp=20`;

    this.search(this.state.mainSearch, 'All', advancedSearchUrl);
  }

  async resultClick(e, link, resultNum, title) {
    e.preventDefault();
    e.stopPropagation();
    let resultTitle = removeFlattenedThunderstoneHTMLTags(title);
    link = decodeHTMLEntities(link);

    let linkData = {
      SearchURL: this.state.currentURL,
      LinkClicked: link,
      ResultNumber: resultNum,
      ResultTitle: resultTitle
    };

    clickTracker(linkData);

    if (link.indexOf('QuickView') > -1) {
      this.initQuickViewer(link, resultTitle, resultNum);
    } else {
      window.open(link, '_blank');
      e.returnValue = false;
    }
  }

  observe(bool) {
    // Options
    var options = {
      root: null, // Page as root
      rootMargin: '100px'
    };
    // Create an observer
    const observer = new IntersectionObserver(
      this.handleObserver.bind(this), //callback
      options
    );
    if (bool) {
      try {
        setTimeout(function () {
          let loadingRef = document.querySelector('#fetch-more-btn');
          if (loadingRef) {
            observer.observe(loadingRef);
          }
        }, 1300);
      } catch (err) {
        console.log(err);
      }
    } else {
      observer.disconnect();
    }
  }

  handleObserver(entities) {
    const y = entities[0].boundingClientRect.y;
    if (this.state.prevY > y || entities[0].isIntersecting) {
      this.getMoreSearchPage();
    }
    this.setState({ prevY: y });
  }

  initQuickViewer(link, title, resultNum) {
    let body = document.body;
    body.classList.add('quickview-modal-open');
    const path = link.split('/');

    const quickview = {
      id: path[path.length - 1],
      title: title,
      isMinimized: false,
      isMaximized: true,
      viewType: path[0],
      resultNum: resultNum
    };

    this.setState({
      activeD365QuickViews: [...this.state.activeD365QuickViews, quickview],
    });
  }

  async pinMe(pinnedItem) {
    this.setState({
      lastPinnedItem: pinnedItem.Id
    });

    const pin = {
      Title: removeFlattenedThunderstoneHTMLTags(pinnedItem.ResultTitle),
      Description: removeFlattenedThunderstoneHTMLTags(pinnedItem.Abstract),
      Link: cleanLinks(pinnedItem),
      Target: targetName(pinnedItem.BackendProfile),
      CollectionId: 0,
      Notes: null,
      Tags: null
    };

    fetchAPI.post('/api/pinItem', {
      body: pin
    })
      .then((pinData) => {
        const toastId = toast(<PinEditor title={pin.Title} description={pin.Description} Id={pinData} edit={() => update()} close={() => toast.dismiss(toastId)} />, {
          position: 'top-right',
          autoClose: 7000,
          hideProgressBar: false,
          closeOnClick: false,
          draggable: false
        });

        function update() {
          toast.update(toastId, { autoClose: false });
        }
      }).catch(error => {
        window.apiError(error);
      });

  }

  getWikiUrl(searchQuery) {
    return `${process.env.REACT_APP_WIKI_URL}${encodeURIComponent(searchQuery)}`;
  }

  render() {
    return (
      <div className={!this.state.additionalView ? 'App' : 'App additional'} style={{ color: 'black !important' }}>
        {!this.state.searchCommit && (
          <Header additionalView={() => this.setState({ additionalView: !this.state.additionalView })} showFeedbackModal={() => this.setState({ showFeedbackModal: true })} />
        )}

        <section id='main-container' className={this.state.pinningScreen ? 'pinning' : ''}>
          {/* MAIN SEARCH PAGE BEGINS */}
          <MainSearch
            mainSearch={this.state.mainSearch}
            setmainSearch={(mainSearch) => this.setState({ mainSearch })}
            searchCommit={this.state.searchCommit}
            onSearch={(searchQuery) => this.search(searchQuery)}
            updateTarget={(target) => this.setState({ setTarget: target })}
            showFeedbackModal={() => this.setState({ showFeedbackModal: true })}
            runTour={() => this.setState({ runTour: true })}
            FetchTipAvailable={(showAll) => { this.setState({ FetchTipAvailable: !this.state.FetchTipAvailable, showAllTips: showAll }); }}
            revertSearchCommit={() => this.setState({ searchCommit: false })}
            performSearchOnSelectedTarget={(searchQuery, target) => this.search(searchQuery, target)}
            setPinning={(pinChange) => { this.setState({ pinningScreen: pinChange !== undefined ? pinChange : !this.state.pinningScreen }); }}
          />
          {/* MAIN SEARCH PAGE ENDS */}

          {this.state.failedMessage && (
            <p style={{ fontSize: '22px', color: 'white' }} >Trouble connecting to Fetch Search Appliance. Are you connected to the network?</p>
          )}

          {/* PINNING */}
          <div style={{ height: '0vh' }}>
            {this.state.pinningScreen && (
              <Pinning resultClick={(e, link, title) => this.resultClick(e, link, 0, title)} />
            )}
          </div>

          {/* SEARCH RESULT PAGE BEGINS */}
          <Row className={this.state.searchCommit ? 'search-results active' : 'search-results'}>

            {(this.state.searchCommit || this.state.isFiltering || this.state.NoData) && (
              <Row style={{ minWidth: '100vw' }} >
                {/* SEARCH DETAILS LEFT - RESULT/ADVANCED FILTERING */}
                <Col lg={{ span: 8 }} xl={{ span: 7 }} className='search-left'>
                  {/* ADVANCED OPTIONS - SYNONYMS/DETAILED */}
                  <Form className='pl-0'>
                    <Form.Check
                      inline
                      type='switch'
                      id='custom-switch'
                      label='Detailed'
                      defaultChecked={this.state.detailedView}
                      onChange={() => this.setState({ detailedView: !this.state.detailedView })}
                    />
                    <Form.Check
                      custom
                      inline
                      label='Exclude Synonyms'
                      type={'checkbox'}
                      name='Synonyms'
                      id={'useSyn-1'}
                      defaultChecked={localStorage.getItem('Synonyms') === 'true' ? true : false}
                      onChange={(e) => { localStorage.setItem('Synonyms', e.target.checked); this.setState({ useSynonyms: e.target.checked }); }}
                    />
                    <Form.Check
                      inline
                      type='switch'
                      id='custom-switch-Quickview'
                      label='Quickview'
                      defaultChecked={this.state.Quickview}
                      onChange={(e) => { localStorage.setItem('quickview', e.target.checked); this.setState({ Quickview: !this.state.Quickview }); }}
                    />

                    {this.state.setTarget === 'SFKB' && (
                      <Dropdown className='d-inline-flex'>
                        <Dropdown.Toggle variant='text' className='language-selector-dropdown p-0'>
                          {this.state.language || 'Language'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => this.setState({ language: 'EN' })}>English</Dropdown.Item>
                          <Dropdown.Item onClick={() => this.setState({ language: 'FR' })}>French</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}

                    <Button variant='link' className='float-right' id='LMFTFY' style={{ color: '#717171', fontSize: '14px' }} onClick={() => generateLMFTFYLink(this.state.SearchURL, this.state.mainSearch)}>
                      {this.state.loadingLink ?
                        'Generating Link...'
                        : <OverlayTrigger
                          placement={'top'}
                          overlay={
                            <Tooltip id={'tooltip-top'}>
                              Generate a link based on this search
                            </Tooltip>
                          }
                        >
                          <span>LMFTFY</span>
                        </OverlayTrigger>}
                      <OverlayTrigger
                        placement={'top'}
                        overlay={
                          <Tooltip id={'tooltip-top'}>
                            Let Me Fetch That For You! - Will generate a link based on this search to send to a colleague
                          </Tooltip>
                        }
                      >
                        <span><i className='far fa-question-circle tooltip-icon'></i></span>
                      </OverlayTrigger>

                    </Button>
                    <div className='page-generated'>LMFTFY link copied to clipboard</div>
                    <input id='page-link' style={{ opacity: '0', transform: 'translate(-1000%, 10px)' }}></input>
                  </Form>
                  <Row id='wiki-cloud-url'>
                    <Col lg={{ span: 12 }} className='no-padding'>
                      <h5 className='search-result-wording' style={{ float: 'left' }}>Can't find what you're looking for? <a id='wiki-cloud-link' href={this.getWikiUrl(this.state.mainSearch)} target="_blank">Search Wiki</a> instead!</h5>
                    </Col>
                  </Row>
                  {/* RESULTS/ADVANCED FILTERING */}
                  {(this.state.searchCommit || this.state.isFiltering || this.state.NoData) && (
                    <Row id='search-result-container'>
                      {(this.state.searchSummary || this.state.isFiltering) && (
                        <Col lg={{ span: 12 }} className='no-padding'>
                          <h5 className='search-result-wording' style={{ float: 'left' }}>Showing Results
                            <span> {this.state.searchSummary.Start} </span> to
                            <span> {this.state.searchSummary.End} </span>
                            {/* <span>{(this.state.activePage + 1) * 10 < this.state.searchSummary.TotalNum ? (this.state.activePage + 1) * 10 : this.state.searchSummary.TotalNum }</span>  */}
                            of <span> {this.state.searchSummary.TotalNum} </span>
                          </h5>
                        </Col>
                      )}
                      <small className='advanced-filter' onClick={() => this.setState(prevState => ({ advanceFiltering: !prevState.advanceFiltering }))}>Advanced Filters <i className='fas fa-chevron-down'></i></small>
                      <Col lg={{ span: 12 }} name='filtering2' className={this.state.advanceFiltering ? 'advanced-filtering active' : 'advanced-filtering'}>
                        <AdvancedFiltering
                          useFilter={(advancedFilters) => this.advancedSearch(advancedFilters)}
                          mainSearch={this.state.mainSearch}
                          selectedFilterArr={this.state.selectedFilterArr}
                          Namespaces={this.state.Namespaces} />
                      </Col>

                      {/* ERROR NOTIFICATION */}
                      {this.state.ErrorNotification.map((items, index) =>
                        <Col key={index} className='w-100 error-notification'>
                          <p className='title'><b>{items.Title}</b></p>
                          <p dangerouslySetInnerHTML={{ __html: items.Details }}></p>
                        </Col>
                      )}

                      {/* GHOST LOADING */}
                      {this.state.isSearching && (
                        <Col lg={{ span: 12 }} className='mx-auto'>
                          <div className='ghost-loading'></div>
                        </Col>
                      )}
                      {/* GHOST LOADING */}

                      {(this.state.searchCommit && this.state.searchResults.length === 0 && !this.state.NoData && !this.state.isSearching) && (
                        <div className='waiting-for-search w-100' style={{ backgroundImage: `url(${NoCommit})` }}>
                          <h4>Ready to search</h4>
                          <h5>Working on a case? Find it here: <img src={arrow} alt='arrow pointing to smart panel' />
                            <br />
                            <small>Need assistance? Find the <i className='far fa-lightbulb'></i> on the case</small>
                          </h5>
                        </div>
                      )}
                      {this.state.NoData && (
                        <div className='no-data-wrapper'>
                          <img src={NoDataAnimation} alt='no data found' />
                          <h4>No Results. Try broadening your search</h4>
                          <h6>Also check out these <a href='https://ceridian.atlassian.net/l/cp/Wmnki4JV'>Search Fundamentals</a></h6>
                        </div>
                      )}
                      {this.state.searchResults.length > 0 && (
                        <div className='page-number-container'>  Page <span className='page-number'>1</span></div>
                      )}
                      {/* START OF RESULTS */}
                      {this.state.searchResults.map((items, index) =>
                        <section key={index} className='result-item' search-index={index} data-target={targetName(items.BackendProfile)}>

                          <div className='search-title-wrapper'>
                            <a href={
                              //Clean the urls - thunderstone sends them through with <b> tags :-(
                              cleanLinks(items, false)}
                              onClick={(e) => this.resultClick(e, cleanLinks(items), index, items.ResultTitle)}>
                              <h5 className='search-title' dangerouslySetInnerHTML={{ __html: boldWords(items.ResultTitle, this.state.searchWords) }}></h5>
                            </a>
                          </div>
                          <div className='quick-options'>
                            {(this.state.Quickview && this.state.hasQuickView.includes(targetName(items.BackendProfile))) && (
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    Open in New Tab
                                  </Tooltip>
                                }
                              >

                                <Button className='quick-view fetch-quick-view' variant='link' onClick={(e) => this.resultClick(e, cleanLinks(items, false), index, items.ResultTitle)}>
                                  <i className='fas fa-angle-double-up'></i>
                                </Button>
                              </OverlayTrigger>
                            )}
                            {(!this.state.Quickview && this.state.hasQuickView.includes(targetName(items.BackendProfile))) && (
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    Open in QuickView
                                  </Tooltip>
                                }
                              >
                                <Button className='quick-view fetch-quick-view' variant='link' onClick={(e) => this.resultClick(e, quickViewLink(items), index, items.ResultTitle)} >
                                  <i className='fas fa-angle-double-up'></i>
                                </Button>
                              </OverlayTrigger>
                            )}

                            {(items.uQuickViewURL !== undefined && items.uQuickViewURL.length > 0 && targetName(items.BackendProfile) !== 'D365') && (
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip>
                                    Open CRM View
                                  </Tooltip>
                                }>
                                <Button className='quick-view' variant='link' onClick={(e) => this.resultClick(e, cleanQuickView(items.uQuickViewURL), index, items.ResultTitle)} >
                                  <i className='fas fa-eye'></i>
                                </Button>
                              </OverlayTrigger>
                            )}

                            <OverlayTrigger
                              placement='top'
                              overlay={
                                <Tooltip>
                                  {this.state.lastPinnedItem === items.Id ? 'Pinned' : 'Pin'}
                                </Tooltip>
                              }>
                              <Button className={this.state.lastPinnedItem === items.Id ? 'quick-view pin-it bounce' : 'quick-view pin-it'} variant='link' onClick={() => this.pinMe(items)} >
                                <i className='fas fa-thumbtack' style={{ fontSize: '16px' }}></i>
                              </Button>
                            </OverlayTrigger>
                          </div>
                          <div className='sub-titles'>
                            <span className='search-target' style={{ color: targetColor(targetName(items.BackendProfile)) }}>
                              {targetName(items.BackendProfile) + ' | '}
                            </span>
                            <span>{(items.uClient !== undefined && items.uClient !== '' && items.uClient.length > 0)  ? items.uClient + ' | ' : '' }</span> 
                            <span style={{fontSize : '13px'}}>{moment(items.Modified).format('YYYY-MM-DD')}</span>
                          </div>

                          <p className='result-body' dangerouslySetInnerHTML={{ __html: boldWords(items.Abstract !== undefined && items.Abstract.length > 0 ? items.Abstract : '', this.state.searchWords) }}></p>
                          {this.state.detailedView && (
                            <div className='detailed-view' >
                              {items.PercentRank !== undefined && items.PercentRank.length > 0 && (
                                <small>{items.PercentRank !== undefined && items.PercentRank.length > 0 ? items.PercentRank + '% Match' : ''}</small>
                              )}

                              {(items.uTicket_Status || items.uStatus || items.uState) !== undefined && (items.uTicket_Status || items.uStatus || items.uState).length > 0 && (
                                <small>{(items.uTicket_Status || items.uStatus || items.uState) !== undefined && (items.uTicket_Status || items.uStatus || items.uState).length > 0 ? 'Status : ' + (items.uTicket_Status || items.uStatus || items.uState) : ''}</small>
                              )}

                              {items.uSeverity !== undefined && items.uSeverity.length > 0 && (
                                <small>{items.uSeverity !== undefined && items.uSeverity.length > 0 ? 'Severity: ' + items.uSeverity : ''}</small>
                              )}

                              {items.uTopic && items.uTopic.length > 0 && (
                                <small>{'Topic: ' + items.uTopic}</small>
                              )}

                              {(items.uCategory && items.uCategory.length > 0) && (
                                <small>{'Category: ' + items.uCategory}</small>
                              )}

                              {((items.uOwnerFullName !== undefined && items.uOwnerFullName.length > 0) && items.uResolved_Date === 'NULL') && (
                                <small>{(items.uOwnerFullName !== undefined && items.uResolved_Date === 'NULL') ? 'Owner Name: ' + items.uOwnerFullName : ''}</small>
                              )}

                              {((items.uResolvedBy !== undefined && items.uResolvedBy.length > 0) && items.uResolved_Date !== 'NULL') && (
                                <small>{(items.uResolvedBy !== undefined && items.uResolved_Date !== 'NULL') ? 'Resolved By: ' + items.uResolvedBy : ''}</small>
                              )}

                              {(items.uResolvedBy !== undefined && items.uResolved_Date !== 'NULL') && (
                                <small>{(items.uResolved_Date !== undefined && items.uResolved_Date !== 'NULL') ? 'Resolved Date: ' + moment(items.uResolved_Date).format('YYYY-MM-DD') : ''}</small>
                              )}

                            </div>

                          )}

                        </section>
                      )}
                    </Row>
                  )}

                  {!this.state.isFiltering && !this.state.isSearching && (
                    <Col lg={{ span: 12 }} className='pages'>
                      {this.state.MoreResultsToCome && (
                        <div>
                          <span className='prev' id='fetching-more-btn'>Fetching More<span className='one'>.</span><span className='two'>.</span><span className='three'>.</span></span>
                          <br />
                          {!this.state.isFetching && (
                            <Button variant='link' onClick={() => this.getMoreSearchPage()} disabled={this.state.isFetching}>Fetch More</Button>
                          )}
                        </div>
                      )}
                      <div id='fetch-more-btn' style={{ height: '140vh', margin: '30px', position: 'absolute', bottom: 0, zIndex: -1, width: '10%' }}></div>
                    </Col>
                  )}

                </Col>
                {/* SEARCH DETAILS RIGHT - SMART PANEL */}
                <Col lg={{ span: 5 }} xl={{ span: 5 }} className='search-right'>
                  <SmartPanel mainSearch={this.state.mainSearch}
                    target={this.state.setTarget}
                    smartPanelDisplay={(e) => this.setState({ smartPanelDisplayed: e })}
                    Namespaces={this.state.Namespaces}
                    ClientNames={this.state.clientArr}
                    ErrorNotification={(err) => this.setState({ ErrorNotification: err })}
                    initQuickView={(link, title) => this.initQuickViewer(link, title)}
                    defaultTab={this.state.defaultSmartPanelTab}
                    passedNamespace={this.state.passedNamespace}
                  />
                </Col>
              </Row>
            )}
          </Row>
          {/* SEARCH RESULT PAGE ENDS */}

          <div className='scroll-top' style={this.state.activeD365QuickViews.length > 0 ? { bottom: '40px' } : {}} onClick={() => window.scrollTo(0, 0)}><i className='fas fa-chevron-up'></i></div>
        </section>

        {/* ANALYTICS PAGE */}
        <section id='analytic-container'>
          {this.state.additionalView && (
            <KPI />
          )}
        </section>


        <footer>
          Made with <i className='fas fa-heart' style={{ color: 'rgb(232, 95, 121)' }}></i> by Cloud Ops
        </footer>

        {/* QUICK VIEWS */}
        {this.state.activeD365QuickViews.map((quickview, index) =>
          <QuickView quickviewData={quickview} index={index} activeD365QuickViews={this.state.activeD365QuickViews} setActiveD365QuickViews={(quickviews) => this.setState({ activeD365QuickViews: quickviews })}>
            {quickview.viewType === 'D365' ?
              <D365CRM D365CRMId={quickview.id} />
              : quickview.viewType === 'Discussions' ?
                <Discussions DiscussionId={quickview.id} mainSearch={this.state.mainSearch} />
                : quickview.viewType === 'TFS' ?
                  <TFS TFSNumber={quickview.id} mainSearch={this.state.mainSearch} />
                  : quickview.viewType === 'Jira' ?
                    <Jira JiraNumber={quickview.id} searchResult={this.state.searchResults[quickview.resultNum]} />
                    : null}
          </QuickView>
        )}

        <Modal show={this.state.showFeedbackModal} dialogClassName='showFeedbackModal active' animation={false}>
          <Feedback mainSearch={this.state.mainSearch} closeModal={() => this.setState({ showFeedbackModal: false })} />
        </Modal>

        {this.state.runTour && (
          <FetchTour searchCommit={this.state.searchCommit} runTour={this.state.runTour} TourCompleted={() => this.setState({ runTour: false })} />
        )}

        {this.state.FetchTipAvailable && (
          <FetchTips showAllTips={this.state.showAllTips} closeTip={() => this.setState({ FetchTipAvailable: false, showAllTips: false })} />
        )}

      </div>
    );
  }


}

export default Fetch;
